export const BASE_URL = process.env.VUE_APP_BASEURL;
export const MULTA_URL = process.env.VUE_APP_MULTASURL;
export const N8N_URL = process.env.VUE_APP_N8NURL;
export const FACE_ID = process.env.VUE_APP_FACE_ID;
export const PASSWORD_HEADER = process.env.VUE_APP_PASSWORD_HEADER;
export const CLOUDINARY_URL = process.env.VUE_APP_CLOUDINARY_URL;
export const CLOUDINARY_UPLOAD_PRESET =
  process.env.VUE_APP_CLOUDINARY_UPLOAD_PRESET;
export const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID;
export const KEY_MAP = process.env.VUE_APP_KEY_MAP;
export const CIDI = process.env.VUE_APP_CIDI;
//url para las paginas de pago en caso de usarse
export const FRONT_URL = process.env.VUE_APP_FRONTURL;
export const FRONT_ENV = process.env.VUE_APP_ENV;
//para saber si conecta socket
export const MULTAS_SOCKET = process.env.VUE_APP_SOCKET_MULTAS;
export const OFFICE_SOCKET = process.env.VUE_APP_SOCKET_OFFICE;
export const VAPID_PUBLIC_KEY = process.env.VUE_APP_VAPID_PUBLIC_KEY;
export const VAPID_PRIVATE_KEY = process.env.VUE_APP_VAPID_PRIVATE_KEY;
export const VAPID_MAIL = process.env.VUE_APP_VAPID_MAIL;

